
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import React, { useContext } from "react";
import { Formik } from "formik";
import { BrandContext } from "../../../contexts/BrandContext";
import BasicInputField from "../form/BasicInputField";
import { getValidationFromFields, initialValues } from "../form/FormUtilities";
import axios from "../../../utils/axios";
import { cWarn } from "../CustomLogger";
import TestRuleDialogue from "../Widgets/SchoolRules/TestRuleDialogue";

export default function UMToggleDialogue(props){
    
    const brandContext = useContext(BrandContext);
    console.log(brandContext);
    const {
        showDialogue,
        setShowDialogue,
        updateCall,
        stb:{
            unac=false,
            walkToCheckin=false,
            id=0
        }
    } = props;

    
    let umOption = true;
    let walkToCheckInOption = true;

    const {
        textContent:{
            walkToCheckinDialogueTitle='',
            widget_cancelButton:cancelButton='',
            confirmButton=''
        },
        brand:{
            schoolConfig=null
        }
    } = brandContext;

    if(schoolConfig !== null){
        ({umOption,walkToCheckInOption} = schoolConfig);
    }
    


    const formFields = {
        'um': {
            'label': 'umButtonLabel',
            'type':'switch',
            'default':unac === true
        },
        'walkToCheckin': {
            'label': 'walkToCheckinLabel',
            'type':'switch',
            'default':walkToCheckin === true
        },
    }

    return (
        <Dialog
            fullWidth
            open={showDialogue}
            onClose={()=>{setShowDialogue(false)}}
        >
            
            <DialogTitle>
                {walkToCheckinDialogueTitle}
            </DialogTitle>
            <Formik
                initialValues={initialValues(formFields)}
                validationSchema={getValidationFromFields(formFields)}
                onSubmit={(values)=>{
                   // console.log(values)
                    const apiPath = `${process.env.REACT_APP_API_URL}/travelcotaxi/umtoggle/${id}`;
                    axios.post(apiPath,{
                        id,
                        unac:values.um,
                        walkToCheckin:values.walkToCheckin
                    },{
                        timeout: 300000,
                        withCredentials:true
                    }).then(res => {
                        const {data} = res;
                        const {stb:stbData} = data;
                        if(stbData){
                            if(updateCall){
                                updateCall(stbData);
                            }
                            setShowDialogue(false);
                        }
                    }).catch(err => {
                       cWarn(err);
                    });
                }}
            >
                {props => (
                    <>
                    <DialogContent>
                            <form onSubmit={props.handleSubmit}>
                                <Grid container spacing={3}>
                                    
                                    {umOption &&
                                    <Grid item xs={12} md={12}>
                                        <BasicInputField
                                            sx={{width:'100%'}}  
                                            formik={props} 
                                            formFields={formFields} 
                                            fieldName="um"
                                            disabled={props.values.walkToCheckin}
                                        />    
                                    </Grid>
                                    }
                                    { walkToCheckInOption &&
                                    <Grid item xs={12} md={12}>
                                        <BasicInputField
                                            sx={{width:'100%'}}  
                                            formik={props} 
                                            formFields={formFields} 
                                            fieldName="walkToCheckin"
                                            disabled={props.values.um}
                                        />
                                    </Grid>
                                    }
                                </Grid>
                            </form>
                    </DialogContent>
                    
                    <DialogActions>
                        <Button onClick={()=>{setShowDialogue(false)}} color="primary">
                            {cancelButton}
                        </Button>
                        <Button onClick={()=>{props.handleSubmit()}} color="primary">
                            {confirmButton}
                        </Button>
                        
                    </DialogActions>
                    </>
                  
                )}
            </Formik>
        </Dialog>
    );

}